"use client"

import { useFormContext } from "react-hook-form"
import { ConsultationStepData } from "../types/type"
import { ConsultationFormSchema } from "../schema/schema"
import { ConsultationCard } from "./consultation-card"
import Express from "~/assets/express.svg"
import Live from "~/assets/live.svg"

interface ConsultationTypeStepProps {
  data: ConsultationStepData
  updateFields: (fields: Partial<ConsultationFormSchema>) => void
}

export const ConsultationTypeStep = ({ 
    data, 
    updateFields 
}: ConsultationTypeStepProps) => {
  const { register, watch, setValue } = useFormContext<ConsultationFormSchema>()
  const selectedConsultationType = watch("consultationType")
  console.log("consultationTypeData", data, selectedConsultationType)

  const handleConsultationSelect = (type: string) => {
    const consultationPrices: { [key: string]: number } = {
      express: 49.99,
      live: 129.99,
    };
    const cost = consultationPrices[type] || 0;
    setValue("consultationType", { name: type, cost }, { shouldValidate: true })
    updateFields({ consultationType: { name: type, cost } })
  }

  return (
    <div className="mx-auto mb-24 w-full sm:max-w-[524px] lg:max-w-[704px]">
      <div className="mb-6 text-center mt-8">
        <h1 className="text-2xl font-medium sm:text-3xl lg:text-4xl">Select Consultation Type</h1>
        <p className="mt-2 text-sm text-[#4B5563] sm:text-base lg:text-lg">
          Choose how you'd like to connect with our medical professionals. Both options include comprehensive care and
          prescription services tailored to your needs.
        </p>
      </div>

      <div className="space-y-4">
        {/* Express Consultation */}
        <ConsultationCard
          type="express"
          title="Express Consultation"
          description="Perfect for busy schedules. Get professional medical review and prescription without scheduling conflicts."
          price="$49.99"
          features={[
            "Comprehensive case review",
            "Personalized treatment plan",
            // "Prescription sent to pharmacy",
          ]}
          icon={Express}
          iconBgColor="bg-[#4272DD]"
          selected={selectedConsultationType?.name === "express"}
          onSelect={handleConsultationSelect}
          register={register}
        />

        {/* Live Video Consultation */}
        <ConsultationCard
          type="live"
          title="Live Video Consultation"
          description="Get face-to-face interaction with your doctor. Ideal for detailed discussions and personalized guidance."
          price="$129.99"
          features={[
            "30-minute live video consultation",
            "Direct Q&A with medical provider",
            "Real-time health assessment",
          ]}
          icon={Live}
          iconBgColor="bg-[#F59E0B]"
          selected={selectedConsultationType?.name === "live"}
          onSelect={handleConsultationSelect}
          register={register}
          additionalInfo="Everything in Express consultation, plus:"
        />
      </div>
    </div>
  )
}
